module.exports = __webpack_public_path__ + "img/porto-7.57cd7534.png";